import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { CONST } from "./utils";
import * as Components from './components';

const theme = createTheme({
  spacing:8,
  palette: {
    primary: {
      main: CONST.Colors.Primary.Main,
    },
    secondary: {
      main: CONST.Colors.Secondary.Main,
    },
  },
});

function App() {
  document.title = 'TjBaGeneral';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path='/' element={<Components.Landing />} />
          <Route path='/tst' element={<Components.Test />} />
          <Route path='/gugle' element={<Components.Gugle />} />
          <Route path='/terms' element={<Components.Terms />} />

          <Route path='/trackstation' element={<Components.TrackStations.Holder />} >
            <Route path='' element={<Components.TrackStations.Login />} />
            <Route path='main' element={<Components.TrackStations.Main title={'TS - Main'} />} />
          </Route>
          <Route path='/ordermanagement' element={<Components.OrderManagement.Holder />} >
            <Route path='' element={<Components.OrderManagement.Login />} />
            <Route path='main' element={<Components.OrderManagement.Main />} />
          </Route>
          <Route path='/productionmanagement' element={<Components.ProductionManagement.Holder />} >
            <Route path='' element={<Components.ProductionManagement.Login />} />
            <Route path='main' element={<Components.ProductionManagement.Main />} />
          </Route>
          <Route path='/baggingstation' element={<Components.BaggingStation.Holder />} >
            <Route path='main' element={<Components.BaggingStation.Main />} />
          </Route>
          <Route path='/shippingstation' element={<Components.ShippingStation.Holder />} >
            <Route path='main' element={<Components.ShippingStation.Main />} />
          </Route>
          <Route path='/shippinglabelerstation' element={<Components.ShippinLabelerStation.Holder />} >
            <Route path='' element={<Components.ShippinLabelerStation.Main />} />
            <Route path='open' element={<Components.ShippinLabelerStation.Open />} />
            <Route path='close' element={<Components.ShippinLabelerStation.Close />} />
            <Route path='config' element={<Components.ShippinLabelerStation.Config />} />
          </Route>
          <Route path='/ordertracker' element={<Components.OrderTracker.Holder />} >
            <Route path='' element={<Components.OrderTracker.Main />} />
          </Route>
          <Route path='/qapolish' element={<Components.QaPolish.Holder />} >
            <Route path='' element={<Components.QaPolish.Main />} />
          </Route>
          <Route path='/qashiping' element={<Components.QaShiping.Holder />} >
            <Route path='' element={<Components.QaShiping.Main />} />
          </Route>
          <Route path='/platformsettings' element={<Components.PlatformSettings.Holder />} >
            <Route path='' element={<Components.PlatformSettings.Login />} />
            <Route path='main' element={<Components.PlatformSettings.Main />} />
          </Route>
          <Route path='/fgsmanagement' element={<Components.FgsManagement.Holder />} >
            <Route path='' element={<Components.FgsManagement.Login />} />
            <Route path='main' element={<Components.FgsManagement.Main />} />
          </Route>
          <Route path='/trackinglookup' element={<Components.TrackingLookup.Holder />}><Route path='' element={<Components.TrackingLookup.Login />} /><Route path='main' element={<Components.TrackingLookup.Main />} /></Route>
            <Route path='/materialtraceability' element={<Components.MaterialTraceability.Holder />} >
            <Route path='' element={<Components.MaterialTraceability.Login />} />
            <Route path='main' element={<Components.MaterialTraceability.Main />} />
          </Route>
          <Route path='/trackingaccess' element={<Components.TrackingAccess.Holder />} >
            <Route path='' element={<Components.TrackingAccess.Login />} />
            <Route path='main' element={<Components.TrackingAccess.Main />} />
          </Route>
          <Route path='/shippinglabelmanagement' element={<Components.ShippingLabelManagement.Holder />} >
            <Route path='' element={<Components.ShippingLabelManagement.Login />} />
            <Route path='main' element={<Components.ShippingLabelManagement.Main />} />
          </Route>
          <Route path='/bomprinting' element={<Components.BomPrinting.Holder />} >
            <Route path='' element={<Components.BomPrinting.Login />} />
            <Route path='main' element={<Components.BomPrinting.Main />} />
          </Route>
          <Route path='/pmlabeling' element={<Components.PmLabeling.Holder />} >
            <Route path='' element={<Components.PmLabeling.Login />} />
            <Route path='main' element={<Components.PmLabeling.Main />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
